const emailConfirmErrors = {
  CONFIRMATION: 'Ya eres Parte de Riivi!',
  CONFIRMATION_MESSAGE: '¡Listo! Te has registrado exitosamente.',
  ALREADY_VALIDATED: '¡Vaya! Esta cuenta ya fue activada, ya puedes iniciar sesión.',
  CONFIRM_TOKEN_EXPIRED: '¡Vaya! Este enlace de activación ya caduco, solicita uno nuevo.'
};

export default emailConfirmErrors;
